import React from 'react';

import LegacyInsuranceSettings from './legacy-insurance';
import { WalletedInsuranceSettings } from './walleted-insurance';
import { SystemAutomationContextProvider, useSystemAutomation } from '../../../contexts/system-automation-context';
import { useEnableInsurancePromoExtended } from '../../../feature-flags/hooks/use-enable-insurance-promo-extended';
import { useCanShowWalletedInsurance } from '../../../services/insurance-service';
import { WalletDataContextProvider } from '../../../wallet/contexts/wallet-data-context-provider';

export const InsuranceSettings = () => {
  const isInsurancePromoEnabled = useEnableInsurancePromoExtended();
  const canShowWalletedInsurance = useCanShowWalletedInsurance();
  const { refreshAutomationRules } = useSystemAutomation();
  if (!isInsurancePromoEnabled && !canShowWalletedInsurance) {
    return <LegacyInsuranceSettings />;
  }

  return (
    <WalletDataContextProvider>
      <SystemAutomationContextProvider>
        <WalletedInsuranceSettings onSettingsSave={refreshAutomationRules} />
      </SystemAutomationContextProvider>
    </WalletDataContextProvider>
  );
};
